import { MessageSquareWarning } from 'lucide-react';

import { SidebarItem } from './SidebarItem';
import { SidebarSection } from './SidebarSection';

export function ObservabilitySidebar({
  isObservabilityEnabled,
  isPoliciesEnabled,
}: {
  isObservabilityEnabled: boolean;
  isPoliciesEnabled: boolean;
}) {
  return (
    <SidebarSection title="Additional Functionality">
      <SidebarItem
        label="Alerting"
        to={
          isObservabilityEnabled ? 'portainer.alerting' : 'portainer.settings'
        }
        params={
          !isObservabilityEnabled ? { section: 'additional-functionality' } : {}
        }
        icon={MessageSquareWarning}
        data-cy="portainerSidebar-alerting"
      />
      <SidebarItem
        label="Policy Based Management"
        to={isPoliciesEnabled ? 'portainer.policies' : 'portainer.settings'}
        params={
          !isPoliciesEnabled
            ? { section: 'additional-functionality-policies' }
            : {}
        }
        icon={MessageSquareWarning}
        data-cy="portainerSidebar-policies"
      />
    </SidebarSection>
  );
}
